/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import EventEmitter from 'eventemitter3';

/**
 * @import { IPlaybackControlsEmitter, PlaybackControlsEmitterEventTypes } from '.'
 * @import { Content } from '../content/content'
 */

/**
 * Lehký správce pro orchestraci akcí ovládání přehrávání řízených uživatelem
 * (např. přeskočení vpřed) v rámci aplikace.
 * @implements {IPlaybackControlsEmitter}
 */
export default class PlaybackControlsEmitter {
  constructor() {
    /** @type {EventEmitter<PlaybackControlsEmitterEventTypes>} */
    this.emitter = new EventEmitter();
  }

  /** @type {IPlaybackControlsEmitter['destroy']} */
  destroy() {
    this.emitter.removeAllListeners();
  }

  /** @type {IPlaybackControlsEmitter['off']} */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @type {IPlaybackControlsEmitter['on']} */
  on(...args) {
    this.emitter.on(...args);
  }

  /**
   * @param {Content} content
   */
  skip(content) {
    this.emitter.emit('skip', content);
  }

  stop() {
    this.emitter.emit('stop');
  }
}
